import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Container, Icon, PageHeader, SubMessage, TitleText } from './DTCopyTextSendMacro.styles';
import { DTCopyText } from '../../Common/DTCopyText/DTCopyText';
import { getDecisionNodeAtPath } from '../../../../extractFromState';
import DTInfoWidget from '../../DTInfoWidget/DTInfoWidget';
import { createLastMileRecord } from '../../../../actions/tools/LastMileActions';
import { setShowConfirmationPage } from '../../../../actions/tools/OrdersSearchActions';
import { handleError } from '../../../../services/ErrorService/ErrorService';
import { setLoadingUnique } from '../../../../actions';
import { twoBtnPopupCreator } from '../../../popups/ConfirmPopup/helper';

const DTCopyTextSendMacroView = (props) => {
  const {
    children,
    buttonText,
    onNextButtonClick,
    hideCopyText,
    disableActionButton,
    popupConfirmationText,
    customErrorMessage,
    customErrorFields,
    skipExtraActions,
  } = props;

  const ERROR_MESSAGES = ['Return is closed and therefore cannot be processed.'];

  const dispatch = useDispatch();
  const decisionNode = useSelector(getDecisionNodeAtPath);

  const setLoading = useCallback((loading) => dispatch(setLoadingUnique(loading, 'CopyTextContainer')), [dispatch]);

  const handleConfirmationPopup = () => {
    twoBtnPopupCreator({
      content: {
        main: popupConfirmationText,
        iconPath: '/images/green-alert-bell.svg',
      },
      btnConfig: {
        dismiss: 'DISMISS',
        confirm: 'CONFIRM',
      },
      onConfirm: () => handleNextButtonClick(),
    });
  };

  const handleNextButtonClick = async () => {
    try {
      setLoading(true);
      await onNextButtonClick();
      if (!skipExtraActions) {
        dispatch(createLastMileRecord());
        dispatch(setShowConfirmationPage());
      }
    } catch (error) {
      const errorMessage = ERROR_MESSAGES.includes(error.message) ? error.message : customErrorMessage;

      handleError({
        error,
        customMessage: errorMessage,
        customFields: customErrorFields,
        showPopup: true,
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <PageHeader>
        <Icon src="/images/attention_icon.svg" alt="attention" />
        {decisionNode.title && <TitleText>{decisionNode.title}</TitleText>}
        {decisionNode.subText && <SubMessage>{decisionNode.subText}</SubMessage>}
      </PageHeader>
      {!!decisionNode.infoWidget && <DTInfoWidget />}
      {children}
      <DTCopyText
        buttonText={buttonText}
        hideCopyText={hideCopyText}
        onNextButtonClick={!!popupConfirmationText ? handleConfirmationPopup : handleNextButtonClick}
        disableActionButton={disableActionButton}
      />
    </Container>
  );
};

DTCopyTextSendMacroView.propTypes = {
  hideCopyText: PropTypes.bool,
  buttonText: PropTypes.string.isRequired,
  onNextButtonClick: PropTypes.func.isRequired,
  disableActionButton: PropTypes.bool,
  popupConfirmationText: PropTypes.string,
  customErrorMessage: PropTypes.string,
  customErrorFields: PropTypes.object,
  skipExtraActions: PropTypes.bool,
};

export default DTCopyTextSendMacroView;
